module.exports = __webpack_public_path__ + "assets/img/ability15.6ad9c533.png";